import React from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { getFormattedCarNumberPlate } from "../../util/carOptionsUtils";
import { currentLanguage } from "../../util/common";
import { Icon, Notifications, Button } from "../shared";
import { useAppNavigation } from "../../hooks";

const EstimationNotificationModal = ({ show, close, selectedEstimation }) => {
  const { t } = useTranslation();
  const { localeRoutes, toUrl } = useAppNavigation();

  const language = currentLanguage();

  const {
    _id,
    comments,
    status,
    carData,
    otherBrand,
    otherModel,
    licencePlate,
    cancelRequestReason
  } = selectedEstimation;
  return (
    <Modal show={show} onHide={close} centered size="xl" className="estimation-comment-modal">
      <Modal.Body className="autohub-modal comments-modal">
        <div className="close-icon">
          <Icon iconName="xmark" onClick={close} />
        </div>

        <div className="image-guide-modal-header">
          <h4>{t("track.notificationModalHeading")}</h4>
          <p>{t("track.notificationModalPara")}</p>
          {comments?.length ? (
            <h6>
              <span>
                {otherBrand || carData[0].brand["value_" + language]}{" "}
                {otherModel || carData[0].product["value_" + language]}
              </span>
              <span>{getFormattedCarNumberPlate(licencePlate)}</span>
            </h6>
          ) : null}
        </div>

        <div className="notifications-container" aria-live="polite" aria-atomic="true">
          <Notifications messages={comments} />
          {status === "Estimation Requested" && (
            <div className="review-notification-btn">
              <Button
                type="blue-roundedRight"
                customize="m-0"
                action={() => toUrl(`${localeRoutes.repairEstimateRequest[language]}/${_id}`)}>
                {t("track.reviewEstimationBtn")}
              </Button>
            </div>
          )}
        </div>

        {cancelRequestReason && (
          <div className="cancel-reason-body">
            <h5>{t("track.estimateCloseReason")}</h5>
            <p className="mb-0">{cancelRequestReason}</p>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default EstimationNotificationModal;
